import { SolLocale, SolLocales } from '@sol/components';

export class AsmLanguage {
  public static readonly en: SolLocale = SolLocales.en;
  public static readonly fr: SolLocale = {
    locale: 'fr',
    languageId: 'fr',
    name: 'Français',
    localName: 'asm-locale.language.fr',
  };
  public static readonly de: SolLocale = {
    locale: 'de',
    languageId: 'de',
    name: 'Deutsch',
    localName: 'asm-locale.language.de',
  };
  public static readonly es: SolLocale = {
    locale: 'es',
    languageId: 'es',
    name: 'Español',
    localName: 'asm-locale.language.es',
  };
  public static readonly ja: SolLocale = {
    locale: 'ja-JP',
    languageId: 'ja',
    name: '日本語',
    localName: 'asm-locale.language.ja',
  };
}
